import { render } from "./man.vue?vue&type=template&id=f0d6e696&scoped=true"
import script from "./man.vue?vue&type=script&lang=js"
export * from "./man.vue?vue&type=script&lang=js"

import "./man.vue?vue&type=style&index=0&id=f0d6e696&scoped=true&lang=less"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d6e696"]])

export default __exports__